export default "__VITE_ASSET__B$kZWHm0__"